import { useEffect } from 'react'

// This component prevents the browser from using the bfcache (Back-Forward Cache) for this page.
// Otherwise, if the user navigates back to this page, it will be broken.
// See https://web.dev/articles/bfcache#observe-page-restored
export default function NoBFCache({ children }) {
  useEffect(() => {
    const handlePageShow = (event: PageTransitionEvent) => {
      if (event.persisted) {
        // If the page is being restored from the bfcache, reload it
        window.location.reload()
      }
    }

    window.addEventListener('pageshow', handlePageShow)

    return () => {
      window.removeEventListener('pageshow', handlePageShow)
    }
  }, [])

  return <>{children}</>
}
